import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a20507"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  "aria-modal": "true",
  "aria-labelledby": "import-payment-requests-title"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-head" }
const _hoisted_5 = {
  id: "import-payment-requests-title",
  class: "modal-card-title is-title-shrink"
}
const _hoisted_6 = ["aria-label"]
const _hoisted_7 = { class: "modal-card-body" }
const _hoisted_8 = { class: "body-content" }
const _hoisted_9 = { class: "modal-intro" }
const _hoisted_10 = {
  class: "csv-format-info",
  "aria-labelledby": "csv-format-title"
}
const _hoisted_11 = {
  id: "csv-format-title",
  class: "section-title has-text-weight-semibold"
}
const _hoisted_12 = { class: "section-description" }
const _hoisted_13 = { class: "format-list" }
const _hoisted_14 = { class: "format-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("code", null, "related_wallet")
], -1))
const _hoisted_16 = { class: "format-example" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "0x1234abcd...", -1))
const _hoisted_18 = { class: "format-row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, [
  /*#__PURE__*/_createElementVNode("code", null, "amount")
], -1))
const _hoisted_20 = { class: "format-example" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "50.00", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "-30.00", -1))
const _hoisted_23 = { class: "format-note" }
const _hoisted_24 = { class: "has-text-weight-semibold" }
const _hoisted_25 = {
  key: 0,
  class: "notification is-success is-light import-status has-file-remove"
}
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = { class: "status-copy" }
const _hoisted_28 = { class: "has-text-weight-semibold" }
const _hoisted_29 = { class: "selected-file-name" }
const _hoisted_30 = ["aria-label", "disabled"]
const _hoisted_31 = { class: "icon" }
const _hoisted_32 = { class: "status-copy" }
const _hoisted_33 = { class: "has-text-weight-semibold" }
const _hoisted_34 = {
  key: 0,
  class: "selected-file-name"
}
const _hoisted_35 = ["aria-label", "disabled"]
const _hoisted_36 = {
  key: 2,
  class: "file is-light is-boxed is-file-picker"
}
const _hoisted_37 = { class: "file-label" }
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "file-cta" }
const _hoisted_40 = { class: "file-icon" }
const _hoisted_41 = { class: "file-label" }
const _hoisted_42 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$gettext("Import payment requests")), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": _ctx.$gettext('Close'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
        }, null, 8, _hoisted_6)
      ]),
      _createElementVNode("section", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$gettext(
                "Upload a CSV file to create multiple payment requests at once."
              )), 1),
          _createElementVNode("section", _hoisted_10, [
            _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$gettext("CSV file format")), 1),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$gettext(
                  "The file must contain 2 columns, the first row must contain the column names."
                )), 1),
            _createElementVNode("dl", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("dd", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$gettext("The other party's wallet address")), 1),
                  _createElementVNode("p", _hoisted_16, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Example")) + ":", 1),
                    _hoisted_17
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("dd", null, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.$gettext("Payment request amount")), 1),
                  _createElementVNode("p", _hoisted_20, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Example")) + ":", 1),
                    _hoisted_21,
                    _createTextVNode(" / "),
                    _hoisted_22
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$gettext("Before importing")), 1),
              _createElementVNode("ul", null, [
                _createElementVNode("li", null, _toDisplayString(_ctx.$gettext("The 0x prefix in wallet addresses is optional.")), 1),
                _createElementVNode("li", null, _toDisplayString(_ctx.$gettext(
                      "Positive amounts are incoming payments; negative amounts are outgoing payments."
                    )), 1)
              ])
            ])
          ]),
          (_ctx.parsedRequests.length > 0 && !_ctx.submissionError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("span", _hoisted_26, [
                  _createVNode(_component_fa_icon, { icon: "check-circle" })
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.$gettext("File validated successfully")), 1),
                  _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.selectedFileName), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.readyRequestsMessage), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "delete file-remove",
                  "aria-label": _ctx.$gettext('Remove file'),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.resetFileSelection && _ctx.resetFileSelection(...args))),
                  disabled: _ctx.isCreating
                }, null, 8, _hoisted_30)
              ]))
            : (_ctx.validationError || _ctx.submissionError)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["notification is-danger is-light import-status", { 'has-file-remove': _ctx.validationError }])
                }, [
                  _createElementVNode("span", _hoisted_31, [
                    _createVNode(_component_fa_icon, { icon: "times-circle" })
                  ]),
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.submissionError
                    ? _ctx.$gettext("Failed to create payment requests")
                    : _ctx.$gettext("The file could not be imported")), 1),
                    (_ctx.selectedFileName)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.selectedFileName), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", null, _toDisplayString(_ctx.submissionError || _ctx.validationError), 1)
                  ]),
                  (_ctx.validationError)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "delete file-remove",
                        "aria-label": _ctx.$gettext('Remove file'),
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetFileSelection && _ctx.resetFileSelection(...args))),
                        disabled: _ctx.isCreating || _ctx.isReading
                      }, null, 8, _hoisted_35))
                    : _createCommentVNode("", true)
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("label", _hoisted_37, [
                    _createElementVNode("input", {
                      class: "file-input",
                      type: "file",
                      name: "payment-requests-file",
                      accept: ".csv",
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleFileSelect && _ctx.handleFileSelect(...args))),
                      disabled: _ctx.isReading
                    }, null, 40, _hoisted_38),
                    _createElementVNode("span", _hoisted_39, [
                      _createElementVNode("span", _hoisted_40, [
                        _createVNode(_component_fa_icon, { icon: "cloud-arrow-up" })
                      ]),
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$gettext("Import file")), 1)
                    ])
                  ])
                ]))
        ])
      ]),
      _createElementVNode("footer", _hoisted_42, [
        _createElementVNode("button", {
          type: "button",
          class: "button custom-button-modal has-text-weight-medium",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.createPaymentRequests && _ctx.createPaymentRequests(...args))),
          disabled: _ctx.parsedRequests.length === 0 || _ctx.isCreating
        }, [
          _createElementVNode("span", _hoisted_44, [
            _createVNode(_component_fa_icon, { icon: "plus-circle" })
          ]),
          _createElementVNode("span", null, _toDisplayString(_ctx.isCreating
                ? _ctx.$gettext("Creating...")
                : _ctx.$gettext("Create payment requests")), 1)
        ], 8, _hoisted_43)
      ])
    ])
  ]))
}